export default function PageJsonLd() {
  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Тренинг по работе с клиентами',
    provider: {
      '@type': 'Person',
      name: 'Алексей Сивко',
      description: 'Бизнес-тренер и консультант с более чем 18-летним опытом в развитии клиентского сервиса, коммуникации и продажах',
      url: 'https://sivko.by/',
    },
    description: 'Практический тренинг по работе с клиентами для компаний. Развиваем навыки коммуникации, сервиса, удержания клиентов, повышения лояльности и роста продаж. Корпоративное обучение под задачи бизнеса.',
    areaServed: ['Беларусь', 'Россия', 'Казахстан', 'Израиль'],
    serviceType: 'Корпоративное обучение работе с клиентами',
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      category: 'Корпоративный тренинг',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Что входит в тренинг по работе с клиентами?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Программа включает: психологию клиента, активное слушание, правильные вопросы, эмпатию, аргументацию, работу с ожиданиями, работу с жалобами и возражениями, конфликтные ситуации, управление эмоциями, сервис после продажи, удержание клиента, повторные продажи, коммуникацию в переписке и по телефону, стандарты общения. 80% времени — практика на реальных кейсах компании.',
        },
      },
      {
        '@type': 'Question',
        name: 'Для кого подходит тренинг?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Для отделов продаж, клиентского сервиса, служб поддержки, call-центров, интернет-магазинов. Подходит для B2B и B2C-компаний: производство, услуги, медицина, образование, недвижимость, банки, страхование, логистика и другие отрасли.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли адаптировать программу под нашу специфику?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, каждая программа разрабатывается индивидуально после диагностики. Мы изучаем ваш продукт, рынок, категорию клиентов, текущий уровень сотрудников. Ни одной шаблонной программы — только то, что работает в вашей нише с вашими клиентами.',
        },
      },
      {
        '@type': 'Question',
        name: 'Сколько длится обучение?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Форматы варьируются: интенсивный тренинг — 1–2 полных дня, модульная программа — от 2 недель до 3 месяцев, комплексная программа с сопровождением — 3–6 месяцев. Точная продолжительность определяется после диагностики и постановки целей.',
        },
      },
      {
        '@type': 'Question',
        name: 'Есть ли онлайн-формат?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, тренинг полностью доступен онлайн: живые сессии с отработкой диалогов и кейсов через видеосвязь, ролевые упражнения, разбор реальных записей коммуникаций. Онлайн-формат сохраняет практическую направленность и эффективность.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли обучить сервис и продажи одновременно?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да. Наш подход как раз соединяет продажи, коммуникацию, сервис и долгосрочные отношения. Мы обучаем сотрудников не просто «хорошо общаться», а выстраивать доверие, выявлять потребности, предлагать ценность и сопровождать клиента — что напрямую влияет на продажи и LTV.',
        },
      },
      {
        '@type': 'Question',
        name: 'Работаете ли вы с B2B-компаниями?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да. В B2B качество коммуникации критически важно: длинный цикл сделки, несколько ЛПР, высокие риски. Обучаем работе со сложными клиентами, закупщиками, коммерческими директорами, выстраиванию долгосрочного партнёрства.',
        },
      },
      {
        '@type': 'Question',
        name: 'Работаете ли вы с B2C-компаниями?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да. В B2C работаем над качеством обслуживания, ростом лояльности, работой с негативом, ростом NPS и среднего чека. Обучаем превращать разовую покупку в долгосрочные отношения.',
        },
      },
      {
        '@type': 'Question',
        name: 'Есть ли сопровождение после тренинга?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, посттренинговое сопровождение — обязательный элемент. Мы разбираем реальные коммуникации участников, поддерживаем в чате, помогаем внедрять стандарты. Без сопровождения эффективность тренинга падает на 70–80% уже через месяц.',
        },
      },
      {
        '@type': 'Question',
        name: 'Как измерить эффективность обучения?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Фиксируем исходные показатели до тренинга и отслеживаем динамику: NPS, удовлетворённость клиентов, количество жалоб, повторные обращения, средний чек, конверсия. Промежуточные замеры через 1 и 3 месяца после обучения.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли использовать реальные кейсы компании?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Это основа методологии. Мы разбираем реальные ситуации участников: звонки, переписки, жалобы, конфликтные кейсы. Участники видят свои реальные зоны роста и отрабатывают новые навыки на знакомом материале.',
        },
      },
      {
        '@type': 'Question',
        name: 'Что получают руководители после обучения?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Руководители получают: единые стандарты общения с клиентами, регламенты работы с жалобами, скрипты для типовых ситуаций, систему контроля качества коммуникации и измеримые метрики роста. А главное — команду, которая самостоятельно справляется со сложными клиентами и приносит повторные продажи.',
        },
      },
    ],
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Главная',
        item: { '@id': 'https://business-training.by/', name: 'Главная' },
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Продажи и переговоры',
        item: { '@id': 'https://business-training.by/prodazhi-i-peregovory/trening-po-prodazham', name: 'Продажи и переговоры' },
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: 'Тренинг по работе с клиентами',
        item: { '@id': 'https://business-training.by/prodazhi-i-peregovory/trening-po-rabote-s-klientami', name: 'Тренинг по работе с клиентами' },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
    </>
  );
}